<script setup lang="ts">
import { startOfDay } from 'date-fns'
import type { UpdateOrCreateDefect } from '~/types'

defineProps<{
  payload: UpdateOrCreateDefect
  showRepairButton: boolean
  isAllowedFullAccess: boolean
  externalWorkshopEmployeeOptions: { label: string | null, value: string }[]
  isReadOnly?: boolean
  isUpdate?: boolean
  isForeignMachinery?: boolean
  onSave: (payload: UpdateOrCreateDefect) => Promise<unknown>
}>()

const emit = defineEmits<{
  (e: 'repair'): void
}>()
</script>

<template>
  <FormKit
    v-slot="{ value }"
    :value="payload.data"
    type="form"
    :disabled="isReadOnly"
    :actions="false"
    @submit="(data: UpdateOrCreateDefect['data']) => onSave({ mode: payload.mode, data } as UpdateOrCreateDefect)"
  >
    <TheDevOnlyNiceJson :form-value="value" />
    <FormKitMultiSelect
      v-if="isAllowedFullAccess"
      class="max-w-md"
      name="externalWorkshopEmployees"
      :is-multi-select-allowed="true"
      :multi-select-options="externalWorkshopEmployeeOptions"
      :label="$t('defect.externalWorkshopEmployee.field.label')"
    />
    <FormKit
      name="description"
      type="textarea"
      :disabled="!isAllowedFullAccess"
      validation="required"
      label="Defekt Beschreibung"
      placeholder="Motor springt nicht an"
    />
    <FormKitFileDropzone
      name="photos"
      label="Defekt Fotos"
      :disabled="false"
      :read-only="isReadOnly"
    />
    <FormKitDate
      v-if="isUpdate"
      name="expectedRepairDate"
      :label="$t('defect.expectedRepairDate.label')"
      :validation="`date_after_or_equal:${startOfDay(new Date())}`"
      :validation-messages="{
        date_after_or_equal: $t('defect.expectedRepairDate.validation.message'),
      }"
    />
    <FormKit
      v-if="isForeignMachinery"
      name="isOnlyShownInternally"
      :disabled="!isAllowedFullAccess"
      type="checkbox"
      :label="$t('defect.createOrEdit.fields.isOnlyShownInternally.label')"
    />
    <div class="flex flex-row gap-2">
      <n-button type="primary" attr-type="submit">
        {{ $t(`defect.createOrEdit.${payload.data.type}.button.submit.text`) }}
      </n-button>
      <n-button v-if="showRepairButton" @click="emit('repair')">
        {{ $t('defect.createOrEdit.button.repair.text') }}
      </n-button>
    </div>
  </FormKit>
</template>
